// @flow

import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';
import { localize } from '@ta/common.i18n';
import classnames from '@ta/common.classnames';
import { Link } from '@ta/common.routing';
import { TripsLink } from '@ta/trips.states';

import styles from './Trips.less';

const Trips = () => {
  const tripsIcon = featureIsEnabled('trips_heart_icon') ? 'heart' : 'suitcase';

  return (
    <TripsLink
      loggedInElement={
        <Link href="/Trips" className={styles.tripsIcon} title={localize('trips_product_name')}>
          <span className={classnames('ui_icon', tripsIcon)} />
          <span className={styles.label}>{localize('trips_product_name')}</span>
          {/* Trips */}
        </Link>
      }
      loggedOutElement={open => (
        <Link className={styles.tripsIcon} title={localize('trips_product_name')} onClick={open}>
          <span className={classnames('ui_icon', tripsIcon)} />
          <span className={styles.label}>{localize('trips_product_name')}</span>
          {/* Trips */}
        </Link>
      )}
    />
  );
};

export default Trips;
